
import { Fragment } from 'vue-fragment';
import VueTypes, { nullable } from 'vue-types';
import { mapGetters } from 'vuex';

export default {
    components: { Fragment },
    props: {
        value: VueTypes.oneOfType([String, Number, nullable]).isRequired,
        currency: VueTypes.oneOfType([String, Number, nullable]).def(null),
    },
    computed: {
        ...mapGetters({
            isNovaPorta: 'global/getIsNovaPorta',
        }),
        handledCurrency() {
            return this.currency === null ? this.$t('currency') : this.currency;
        },
        label() {
            return this.isNovaPorta ? `${this.$t('currencyNovaPorta')} ${this.price}` : `${this.price} ${this.handledCurrency}`;
        },
        price() {
            const num = Number(this.value);
            return Number.isInteger(num) ? String(num) : num.toFixed(2);
        },
    },
};
